



import { Component, Vue, Watch } from 'vue-property-decorator'
import * as qs from 'qs'
import { isWeixin } from '@ivy/fts/utils'
import * as utils from '@ivy/fts/utils'
import { requireGet, requirePost } from './require'
import config from '../../config'

@Component
export default class Index extends Vue {
  tid: any
  out_trade_no: any
  channel_id: any

  async created() {
    const { result, total_fee, tid, out_trade_no, channel_id } = qs.parse(
      this.$route.query
    )
    this.tid = tid
    this.out_trade_no = out_trade_no
    this.channel_id = channel_id
    if (isWeixin() && total_fee > 0 && !result.includes('chooseWXPay:ok')) {
      this.$router.go(-1)
    }
    if (total_fee > 0) {
      await this.sendOkInfo()
    } else {
      //0元直接成功
      this.jumptopayDone()
    }
  }

  //发送支付成功消息
  async sendOkInfo() {
    let { data } = await this.$axios.post(
      `/api/goods/order/pay/callback`,
      {
        out_trade_no: this.out_trade_no,
        type: 'wechat',
      },
      {
        disableAlert: true,
      }
    )
    if (data.code != 200) {
      this.$Toast(data.message)
      //失败
      this.$router.go(-1)
      return
    } else {
      //成功
      this.jumptopayDone()
    }
  }
  jumptopayDone() {
    let host =
      config.env === 'production' ? window.location.host : 'm.ivydad.com.cn'
    if (host.indexOf('simulate') >= 0) host = 'm.ivydad.com'
    const resultUrl = `//${host}/goods/payDone?tid=${this.tid}&channel_id=${
      this.channel_id
    }&result=ok`
    window.location.replace(resultUrl)
  }
}
